import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { SanitizedText } from '@/ui/SanitizedDom';
import LiConnectionRequestIcon from '@/assets/icons/colored/ConnectionRequest';
import LiInMailIcon from '@/assets/icons/colored/Linkedin';
import EmailIcon from '@/assets/icons/colored/Email';

import { getDelayById } from '@/pages/mco/steps/components/step/delay';

export const getIcon = (channel) => {
  if (!channel) return null;
  switch (channel) {
    case 'email':
      return EmailIcon;
    case 'li_inmail':
      return LiInMailIcon;
    case 'li_connection':
      return LiConnectionRequestIcon;
    default:
      return null;
  }
};

export const StepCard = ({ children, isLast = false }) => {
  return (
    <Box>
      <Box>{children}</Box>
      <Flex h="24px" justifyContent="center">
        {!isLast && (
          <Box borderRightWidth="1px" borderColor="border-color"></Box>
        )}
      </Flex>
    </Box>
  );
};

export const StepView = ({ step = {}, onOpen = () => {} }) => {
  const stepInterval = getDelayById(step?.step_interval);

  return (
    <Box
      cursor="pointer"
      borderWidth="1px"
      borderColor="border-color"
      bg="white"
      borderRadius="12px"
      onClick={onOpen}
    >
      <Flex
        p="12px 24px"
        borderRadius="12px 12px 0 0"
        bg="rgba(155, 155, 155, 0.1)"
        borderBottomColor="#E5E5E5"
        borderBottomWidth="1px"
        h="60px"
        alignItems="center"
      >
        <Flex alignItems="center" width="300px">
          <Icon
            width="36px"
            height="36px"
            as={getIcon(step?.channel)}
            color="#2D64BC"
            borderRadius="8px"
          />
          <Text fontSize="16px" fontWeight="semiBold" ml="12px">
            Step {step?.step} :
          </Text>
          <Text fontSize="14px" ml="4px" flex="1">
            {step?.name}
          </Text>
        </Flex>
        <Box width="200px">
          <Text>{step?.mode === 'auto' ? 'Automatic' : 'Manual'}</Text>
        </Box>
        <Flex flex="1">
          <Text textAlign="center" fontWeight="semiBold">
            Schedule in:
          </Text>
          <Text textAlign="center" ml="6px">
            {stepInterval?.label}
          </Text>
        </Flex>
        <Box width="50px">
          <Text color="#0043CE" fontWeight="medium">
            Show
          </Text>
        </Box>
      </Flex>
      <Flex h="72px" p="12px 24px">
        <Flex>
          <Box
            width={{
              base: '280px',
              xl: '280px',
              '2xl': '390px',
            }}
          >
            <Text fontWeight="semiBold" fontSize="14px">
              {step?.template?.subject}
            </Text>
            <SanitizedText
              variant="muted"
              html={step?.template?.body?.substring?.(0, 25)}
            />
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};
